import { Outlet } from 'react-router';
import Header from '../components/layout/Header';
import FarmSearch from '../components/farm/FarmSearch';
import Content from '../components/layout/Content';

const HomeLayout = () => {
  return (
    <>
      <Header>
        <FarmSearch />
      </Header>
      <Content>
        <Outlet />
      </Content>
    </>
  );
};

export default HomeLayout;
